import { NgModule, ModuleWithProviders } from "@angular/core";
import {  ReactiveFormsModule } from '@angular/forms';
// import { NgScrollbarModule } from 'ngx-scrollbar';
// import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { NgxDatatableModule } from "@swimlane/ngx-datatable";
// import { ClickOutsideModule } from "ng4-click-outside";
import { TabsModule } from "ngx-bootstrap/tabs";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { ConfirmModalComponent } from "./confirm-modal/confirm-modal.component";
// import { ModalModule } from "ngx-bootstrap/modal";
import { NgxSmartModalModule } from 'ngx-smart-modal';

import { TooltipModule } from "ngx-bootstrap/tooltip";
// import { AlertModule } from "ngx-bootstrap";
// import { UiSwitchModule } from "ngx-toggle-switch";
import { NgSelectModule } from "@ng-select/ng-select";
import { SharedService } from "./shared.service";
import { NumberOnlyDirective } from "./number-only.directive";
// import { EditorModule } from "@tinymce/tinymce-angular";
import { LoaderComponent } from './loader/loader.component';
import { FormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
// import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
// import { A11yModule } from '@angular/cdk/a11y'; // 👈 Add this!

import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatchvisionModalsModule} from "../matchvision-modals/matchvision-modals.module"
import { EditorComponent } from './editor/editor.component';
@NgModule({
  declarations: [ConfirmModalComponent, NumberOnlyDirective, LoaderComponent, EditorComponent],
  imports: [
    CommonModule,
    NgxSmartModalModule.forRoot(),
    // TabsModule.forRoot(),
    // BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    // ProgressbarModule.forRoot(),
    // ModalModule.forRoot(),
    TooltipModule.forRoot(),
    // // AlertModule.forRoot(),
    // // UiSwitchModule,
    // NgSelectModule,
    NgSelectModule,
    NgxDatatableModule,
    // EditorModule,
    AngularEditorModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatChipsModule,
		MatIconModule,
		MatInputModule,
    MatFormFieldModule,
    MatMenuModule,
    MatButtonModule,
    MatchvisionModalsModule,
    // A11yModule
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    NgScrollbarModule ,
    // TabsModule,
    // BsDatepickerModule,
    // BsDropdownModule,
    // ProgressbarModule,
    // ModalModule,
    TooltipModule,
    BsDropdownModule,
    // // AlertModule,
    // // UiSwitchModule,
    // NgSelectModule,
    // NgxDatatableModule,
    // NumberOnlyDirective,
    // // ClickOutsideModule,
    // EditorModule,
    EditorComponent
  ],
  // entryComponents: [ConfirmModalComponent],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [SharedService],
    };
  }
}
